import styled, { css } from "styled-components";
export const ReceiverContStyled = styled.div`
  background-color: #ecedf0;
  padding: 10px;
  border-radius: 12px;
  margin: 10px 0;
  display: flex;
  flex-direction: column;
`;
export const Destenitions = styled.div`
  display: flex;
  align-items: center;
`;
export const BoldText = styled.div`
  font-weight: bold;
  font-size: 14px;
  margin: 0 2px;
`;
export const BlureText = styled.div`
  color: #353a50;
  opacity: 0.5;
  margin: 0 2px;
`;
export const FullAdress = styled.div`
  font-size: 10px;
  margin: 10px 5px 0 0;
`;
export const ReceiverInfoStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;
export const R = styled.div`
  background-color: #fff;
  width: 45%;
  padding: 4px 6px;
  border-radius: 8px;
`;
export const BtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const BtnStyled = styled.div`
  padding: 3px 25px;
  border-radius: 8px;
  background-color: #2a2e43;
  color: #fff;
  text-align: center;
`;
